import React, {useEffect, useState} from "react";
import {Puff} from "react-loader-spinner";

export const Loader = () => {
    return (
        <>
            <div className={"loader-wrapper"}>
                <div className={"puff-container"}>
                    <Puff
                        height={80}
                        width={80}
                        radius={1}
                        color={"#1291D2"}
                        ariaLabel={"puff-loading"}
                        wrapperStyle={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            margin: "-50px 0 0 -50px"
                        }}
                        wrapperClass={""}
                        visible={true}/>
                </div>
            </div>
        </>
    )
}